<template>
  <div class="wrapper">
    <main>
      <slo-auth :initialTab="initialTab" @change="handleTabChange($event)" @formSubmit="next">
        <template v-slot:auth-header>
          <h2 v-if="tab === 'login'">{{ 'Sign in to your account' | t }}</h2>
          <h2 v-if="tab === 'register'">{{ 'New customer? Create an account.' | t }}</h2>
          <div v-if="tab === 'register'" class="slo-auth-account-benefits">
            <p>
              {{ 'Enjoy these benefits with your new account.' | t }}
            </p>
            <ul>
              <li>{{ 'Track your Sloan Marketplace orders' | t }}</li>
              <li>{{ 'Store and manage addresses' | t }}</li>
              <li>{{ 'Create, view, and share DesignSpec projects' | t }}</li>
            </ul>
          </div>
        </template>
      </slo-auth>
      <OrderStatusLookup />
    </main>
  </div>
</template>

<script>
import t from '../../main/i18n';
import {mapGetters} from 'vuex';
import SloAuth from '../../../lib/components/SloAuth.vue';
import OrderStatusLookup from '../components/OrderStatusLookup.vue';

export default {
  components: {
    SloAuth,
    OrderStatusLookup
  },
  props: {
    initialTab: {type: String}
  },
  data() {
    return {
      tab: this.initialTab
    };
  },
  filters: {
    t
  },
  created() {
    if (this.$route.query?.sessionExpired) {
      this.$snotify.clear();
      this.$snotify.info(
        t('Your session expired, please sign in again'),
        {timeout: 4000}
      );
    }

    if (this.authenticated) {
      this.$router.push('/marketplace');
    }
  },
  computed: mapGetters('auth', ['authenticated', 'user']),
  methods: {
    handleTabChange(tab) {
      this.tab = tab;
      this.$router.push(`/marketplace/auth/${tab}`);
    },
    next() {
      this.$router.push('/marketplace');
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.wrapper {
  min-height: calc(100vh - 128px);
  display: flex;
  align-items: flex-start;
  justify-content: start;
  padding: 64px 0;
  color: $color-gray-900;

  @media (min-width: $screen-md) {
    padding: 128px 0;
  }
}

main {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  gap: 3.2rem;
  width: 100%;
  margin: 0;

  @media (min-width: 767px) {
    flex-direction: row;
    justify-content: center;
  }
}

.msie main {
  margin: 0;
}

.slo-auth {
  width: 100%;
  max-width: 464px;
  padding: 1.6rem;
  border: 1px solid #d1d5db;
  border-radius: 12px;

  @media (min-width: 767px) {
    padding: 3.2rem;
  }
}

:deep(.slo-auth) {
  flex: 1;
  text-align: left;

  nav {
    border-bottom: 1px solid #d1d5db;

    > ul {
      justify-content: start;
      padding: 0;
      margin-bottom: -2px;

      li {
        @include text('sm');
        text-transform: uppercase;

        &.slo-tab button {
          font-weight: 500;
          color: $color-gray-700;
        }
      }
    }
  }
}

.slo-auth-account-benefits {
  padding: 1.6rem;
  background-color: $color-gray-100;
  border-radius: 8px;

  ul {
    padding-inline-start: 20px;

    li {
      @include text('sm');
    }
  }
}

h2 {
  @include text('xl', 'strong');
  margin-block: 3.2rem;
}

p {
  @include text('base');
  margin-block-end: 8px;
}

.password-reset-success {
  color: #006bb6;
  padding: 15px;
  background-color: transparent;
  border: 1px solid #006bb6;
}
</style>
